
const jwt = require("jsonwebtoken");
const { SuccessResponse, ErrorResponse } = require("./response");

const create_jwt = (data, key, expiry_sec) => {
  try {
    return SuccessResponse(jwt.sign(data, key, { expiresIn: expiry_sec} ));
  } catch (err) {
    return ErrorResponse(err);
  }
}

const decode_jwt = (token, key) => {
  try {
    return SuccessResponse(jwt.verify(token, key));
  } catch (err) {
    return ErrorResponse(err);
  }
};

module.exports = {
  create_jwt, decode_jwt,
};